export default function () {
  const countrySetting = useCookie<CountryType | undefined>(
    'country_setting',
    {
      default: () => undefined,
      maxAge: 360 * 24 * 60 * 60,
    },
  )

  function initCountrySetting(ipAddressCountry: string) {
    if (!countrySetting.value) {
      if (ipAddressCountry === 'HU') {
        countrySetting.value = 'HU'
      }
      else if (ipAddressCountry === 'TR') {
        countrySetting.value = 'TR'
      }
      else if (ipAddressCountry === 'UA') {
        countrySetting.value = 'UA'
      }
      else {
        countrySetting.value = 'DE'
      }
    }
  }

  function updateCountrySetting(country: CountryType) {
    countrySetting.value = country
  }

  return {
    countrySetting, initCountrySetting, updateCountrySetting,
  }
}
